import React from "react";
import SimpleModal from "../../../SimpleModal";
import "./index.css";
import Util from "../../../../global/utils/Helpers";
import { Field } from "react-final-form";
import FieldDisabled from "../../FieldDisabled";
import { schema } from "./WageModalSchema";
import FieldResolver from "../../FieldResolver";
import Label from "../../UI/Label";
import RequiredAsterisk from "../../UI/RequiredAsterisk";
import Tooltip from "../../UI/FormTooltip";
import { NumericFormat } from "react-number-format";
import classNames from "classnames";
import FieldError from "../../FieldError";
import { validator } from "../../validation";

import WageCalcHelper from "./helper";
import data from "../../../../data/schema/shared/sharedData";

class WageCalculator extends React.Component {
  constructor(props) {
    super(props);
    const { formApi } = props;

    let soc_code = formApi.getState().values["b2_soc_code"];
    let soc_title = formApi.getState().values["b3_soc_title"];
    let full_time = formApi.getState().values["b4_is_full_time"];
    let wage_per = full_time === "NO" ? "Hour" : "- Select -";
    let rdFlag = WageCalcHelper.socCodeCheck(soc_code);
    const date_series = data.wageDateSeries;

    this.state = {
      showModal: false,
      OES_state: undefined,
      OES_date_source: date_series,
      OES_collection_type: undefined,
      OES_area: undefined,
      OES_area_label: undefined,
      OES_area_based: undefined,
      OES_soc_code: soc_code,
      OES_soc_title: soc_title,
      OES_wage_level: undefined,
      OES_rd_flag: rdFlag,
      OES_per: wage_per,
      wageRates: {},
      levelOptions: [],
      prevailingWage: undefined,
      showWageWarning: false,
      showUseOtherOptions: false,
      disableSubmitOtherOptions: false,
      ratesNotFound: false,
    };
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { formApi } = this.props;
    if (
      prevState.OES_area_based !== this.state.OES_area_based ||
      prevState.OES_state !== this.state.OES_state
    ) {
      this.setState({ OES_area: "" });
      formApi.change("OES_area", "");
    }
  };

  handleClick = (e) => {
    let formApi = this.props.formApi;
    this.handleClear(e, formApi);
    this.setState({ showModal: !this.state.showModal });
  };

  handleSubmit = (e, formApi) => {
    let countyObj = "";
    let countyOptions = this.props.counties[this.state.OES_state];
    const areaLabel = this.state.OES_area_label.toUpperCase();
    
    countyOptions.forEach((county) => {
      const countyLabel = county.label.toUpperCase();
      if (areaLabel.startsWith(countyLabel)) {
        countyObj = county;
      }
    });
    formApi.change("_section_f_f7_work_county_id", countyObj);

    const mapping = {
      OES_state: "_section_f_f8_work_state_id",
      OES_date_source: "_section_f_f13b_source_year",
      OES_wage_level: "_section_f_f13a_wage_level",
      OES_per: "_section_f_f11a_prevailing_wage_per",
      prevailingWage: "_section_f_f11_prevailing_wage",
    };
    let state = this.state;
    formApi.batch(() => {
      Object.keys(mapping).forEach(function (key) {
        formApi.change(mapping[key], state[key]);
      });
    });
    this.setState({ showModal: false });
  };

  handleCancel = (e, formApi) => {
    this.handleClear(e, formApi);
    this.setState({ showModal: false });
  };

  handleClear = (e, formApi) => {
    let full_time = formApi.getState().values["b4_is_full_time"];
    let values = [
      "OES_state",
      "OES_collection_type",
      "OES_area",
      "OES_area_label",
      "OES_area_based",
      "OES_wage_level",
      "OES_rd_flag",
      "OES_highly_comp_flag",
      "prevailingWage",
    ];

    if (full_time !== "NO") {
      values.push("OES_per");
      this.setState({ OES_per: undefined });
    }

    formApi.batch(() => {
      Object.keys(values).forEach(function (key) {
        formApi.change(values[key], undefined);
      });
    });

    let rdFlag = WageCalcHelper.socCodeCheck(
      formApi.getState().values["b2_soc_code"]
    );

    this.setState({
      OES_state: undefined,
      OES_collection_type: undefined,
      OES_area: undefined,
      OES_area_based: undefined,
      OES_area_label: undefined,
      OES_wage_level: undefined,
      OES_highly_comp_flag: undefined,
      OES_rd_flag: rdFlag,
      wageRates: {},
      levelOptions: [],
      prevailingWage: undefined,
      showWageWarning: false,
      showUseOtherOptions: false,
    });
  };

  handleClearPW = (formApi) => {
    let values = [
      "OES_wage_level",
      "OES_rd_flag",
      "prevailingWage",
      "OES_highly_comp_flag",
    ];

    formApi.batch(() => {
      Object.keys(values).forEach(function (key) {
        formApi.change(values[key], undefined);
      });
    });

    this.setState({
      OES_wage_level: undefined,
      wageRates: {},
      levelOptions: [],
      prevailingWage: undefined,
    });
  };

  updateCountyLabel = (value, machine_name) => {
    this.setState({
      OES_area_label: value.label,
    });
  };

  handleChange = (value, machine_name, formApi) => {
    if (value.target) {
      value =
        value.target.value === "- Select -" ? undefined : value.target.value;
    }
    this.setState({ [machine_name]: value });
    switch (machine_name) {
      case "OES_collection_type":
        this.handleClearPW(formApi);
        break;
      case "OES_state":
        this.setAreaOptions(value);
        this.handleClearPW(formApi);
        break;
      case "OES_area":
        if (this.state.OES_area_based === "BLS Area") {
          this.setSecondaryCountyOptions(value);
          this.setState({ OES_secondary_county: undefined });
          formApi.change("OES_secondary_county", undefined);
        }
        this.handleClearPW(formApi);
        break;
      case "OES_per":
        this.updatePrevailingWage(value, "OES_per");
        break;
      case "OES_wage_level":
        this.updatePrevailingWage(value, "OES_wage_level");
        break;
      case "OES_highly_comp_flag":
        this.updateHighlyCompFlags(value);
        break;
      default:
    }
  };

  updatePrevailingWage = (value, machineName) => {
    if (value !== "- Select -") {
      if (machineName === "OES_per") {
        if (this.state.OES_wage_level && this.state.OES_wage_level !== "N/A") {
          let perOption = value.toLowerCase();
          let wages = this.state.wageRates[this.state.OES_wage_level];
          let prevailingWage = wages[perOption];
          this.setState({
            prevailingWage: prevailingWage,
          });
        } else if (
          this.state.OES_wage_level &&
          this.state.OES_wage_level === "N/A"
        ) {
          this.handleMissingWageLevel(value.toLowerCase());
        }
      } else if (machineName === "OES_wage_level") {
        if (this.state.OES_per && value !== "N/A") {
          let wages = this.state.wageRates[value];
          let prevailingWage = wages[this.state.OES_per.toLowerCase()];
          this.setState({
            prevailingWage: prevailingWage,
          });
        } else if (this.state.OES_per && value === "N/A") {
          this.handleMissingWageLevel(this.state.OES_per.toLowerCase());
        }
      }
    }
  };

  updateHighlyCompFlags(value) {
    if (value === "YES") {
      this.setState({
        OES_wage_level: undefined,
        wageRates: [],
        levelOptions: ["N/A"],
        showWageWarning: true,
        prevailingWage: undefined,
        showUseOtherOptions: false,
        disableSubmitOtherOptions: false,
      });
    } else {
      this.setState({
        OES_wage_level: undefined,
        wageRates: [],
        levelOptions: [],
        showWageWarning: false,
        showUseOtherOptions: true,
        prevailingWage: undefined,
        disableSubmitOtherOptions: true,
      });
    }
  }

  handleMissingWageLevel = (perOption) => {
    let prevailingWage = "";
    switch (perOption) {
      case "hour":
        prevailingWage = "115.00";
        break;
      case "week":
        prevailingWage = "4600.00";
        break;
      case "bi-weekly":
        prevailingWage = "9200.00";
        break;
      case "month":
        prevailingWage = "19933.33";
        break;
      case "year":
        prevailingWage = "239200.00";
        break;
      default:
    }
    this.setState({
      prevailingWage: prevailingWage,
    });
  };

  setAreaOptions = (state) => {
    let apiIndex = Util.buildFullUrl(`/auth/wageCalc/getAreaOptions?state=${encodeURIComponent(state)}`);

    fetch(apiIndex, {
      credentials: "include",
      method: "GET",
      headers: {
        Authorization:
          "Basic " +
          window.btoa("flagdevteam1:account-standard-xxxxx44xx3xxxxxxxxxxxx1"),
      },
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          areaOptions: data.areaOptions,
          countyOptions: data.countyOptions,
        });
      })
      .catch((error) => console.log(error));
  };

  setSecondaryCountyOptions = (area) => {
    const state = this.state.OES_state;
    let apiIndex = Util.buildFullUrl(`/auth/wageCalc/getCounties?area=${encodeURIComponent(area)}&state=${encodeURIComponent(state)}`);

    fetch(apiIndex, {
      credentials: "include",
      method: "GET",
      headers: {
        Authorization:
          "Basic " +
          window.btoa("flagdevteam1:account-standard-xxxxx44xx3xxxxxxxxxxxx1"),
      },
    })
      .then((response) => response.json())
      .then((data) => {
        const filteredAndSorted = data
          .filter((county) => county.state === this.state.OES_state)
          .sort((a, b) => a.label.localeCompare(b.label));

        this.setState({
          secondaryCountyOptions: filteredAndSorted,
        });
      })
      .catch((error) => console.log(error));
  };

  handleCalculate = (e, formApi) => {
    let data = {
      collectionType: WageCalcHelper.setCollectionType(
        this.state.OES_collection_type
      ),
      socCode: this.state.OES_soc_code,
      area: this.state.OES_area.toString(),
      areaBasedOn: WageCalcHelper.setAreaBasedOn(this.state.OES_area_based),
      rdFlag: this.state.OES_rd_flag,
      highCompFlag: this.state.OES_highly_comp_flag,
    };

    let apiIndex = Util.buildFullUrl("/auth/wageCalc/getWageRate");

    fetch(apiIndex, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Basic " +
          window.btoa("flagdevteam1:account-standard-xxxxx44xx3xxxxxxxxxxxx1"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        if (!data.rates) {
          this.setState({
            OES_wage_level: undefined,
            wageRates: [],
            prevailingWage: undefined,
            ratesNotFound: true,
          });
        } else {
          let wageRates = data.rates;
          let wageLevelOptions = Object.keys(wageRates);
          this.setState({
            OES_wage_level: undefined,
            wageRates: wageRates,
            levelOptions: wageLevelOptions,
            prevailingWage: undefined,
            showUseOtherOptions: false,
            showWageWarning: false,
            disableSubmitOtherOptions: false,
            ratesNotFound: false,
          });
        }

        //only change per for full time
        if (formApi.getState().values["b4_is_full_time"] !== "NO") {
          this.setState({ OES_per: undefined });
          formApi.change("OES_per", undefined);
        }

        formApi.batch(() => {
          formApi.change("OES_wage_level", undefined);
          formApi.change("prevailingWage", undefined);
        });
      })
      .catch((error) => console.log(error));
  };

  render() {
    const {
      // meta: { error, touched },
      schemaProps,
      formValues,
      // width,
      machine_name,
      // input,
      formApi,
      // disabled,
      counties,
    } = this.props;
    let disableCalculate = WageCalcHelper.fieldsFilled(this.state);
    let inputRowClassesBox = classNames("input-wage");

    const wageRateStyle = {
      backgroundColor: "#ffffff",
      border: "1px solid #5B616B",
      height: "2.5rem",
      marginTop: ".5rem",
      maxWidth: "30rem",
      padding: ".5rem",
    };

    return (
      <div>
        <SimpleModal
          toggleModal={(e) => this.handleClick(e)}
          modalStatus={this.state.showModal}
          renderButton={() => (
            <button
              className={
                "usa-button usa-button usa-button-primary wage-calc-button"
              }
              type="button"
              disabled={this.state.OES_soc_code === undefined}
              onClick={(e) => this.handleClick(e)}
            >
              OES Wage Calculator
            </button>
          )}
        >
          <div className={"wage-calculator-modal"}>
            <div className={"case-lookup-heading"}>
              <h3>Calculate OES Prevailing Wage</h3>
            </div>
            <div className={"wage-calculator-form"}>
              {schema.fields.map((field, index) => {
                if (!field.isGroup) {
                  if (
                    field.machine_name === "OES_wage_level" ||
                    field.machine_name === "OES_per" ||
                    field.machine_name === "OES_highly_comp_flag"
                  ) {
                    return null;
                  }
                  let input_resolver = FieldResolver;
                  let component = input_resolver(field.widget) || "input";
                  let schemaProps = { ...field };
                  let showRequired =
                    field.validate && field.validate[0] === "required";
                  let disabled = { background: "#D3D3D3" };
                  let value = undefined;
                  // let disableOverride = false;
                  let areaOrCounty;

                  switch (this.state.OES_area_based) {
                    case "BLS Area":
                      areaOrCounty = "areaOptions";
                      break;
                    case "County/Township":
                      areaOrCounty = "countyOptions";
                      break;
                    default:
                      areaOrCounty = undefined;
                  }
                  let areaCountyOptions = {
                    areaOptions: this.state.areaOptions,
                    countyOptions: this.state.countyOptions,
                    secondaryCountyOptions: this.state.secondaryCountyOptions,
                    areaOrCounty: areaOrCounty,
                    state: this.state.OES_state,
                    ignoreStates: [
                      "AMERICAN SAMOA",
                      "FEDERATED STATES OF MICRONESIA",
                      "MARSHALL ISLANDS",
                      "PALAU",
                    ],
                  };
                  if (field.machine_name === "OES_soc_title") {
                    value = this.state.OES_soc_title;
                  } else if (field.machine_name === "OES_soc_code") {
                    value = this.state.OES_soc_code;
                  } else if (field.machine_name === "OES_date_source") {
                    value = this.state.OES_date_source;
                  } else if (field.machine_name === "OES_per") {
                    value = this.state.OES_per;
                  } else if (field.machine_name === "OES_secondary_county") {
                    if (this.state.OES_area_based !== "BLS Area") {
                      return "";
                    } else if (this.state.OES_area === "") {
                      return "";
                    } else {
                      showRequired = true;
                    }
                  }

                  return (
                    <div>
                      {field.label && (
                        <Label
                          hidden={field.hidden || field.labelHidden}
                          htmlFor={machine_name}
                        >
                          {field.code && <span>{`${field.code}. `}</span>}
                          <span
                            dangerouslySetInnerHTML={{
                              __html: field.label,
                            }}
                          />
                          <RequiredAsterisk
                            show={showRequired || schemaProps.required === true}
                          />
                          {field.tooltip && <Tooltip content={field.tooltip} />}
                        </Label>
                      )}
                      <Field
                        key={index + field.machine_name}
                        id={field.machine_name}
                        name={field.machine_name}
                        formApi={formApi}
                        formValues={formValues}
                        component={component}
                        type={field.widget}
                        disabled={
                          field.disabled && field.disableWhenField !== undefined
                            ? FieldDisabled(
                                field.disabled,
                                field.disableWhenField,
                                formApi
                              )
                            : field.disabled
                        }
                        validate={(values, allValues) =>
                          field.validate
                            ? validator(
                                field.validate,
                                allValues,
                                undefined,
                                counties
                              )(values)
                            : undefined
                        }
                        style={field.disabled ? disabled : undefined}
                        schemaProps={schemaProps}
                        defaultValue={
                          value !== undefined
                            ? value
                            : field.value !== undefined
                            ? field.value
                            : field.choice !== undefined
                            ? field.choice
                            : undefined
                        }
                        showRequired={showRequired}
                        hidden={field.hidden}
                        inputOnChange={(e) => {
                          this.handleChange(e, field.machine_name, formApi);
                        }}
                        passLabelBack={(e) => {
                          this.updateCountyLabel(e, field.machine_name);
                        }}
                        counties={counties}
                        lookupState={this.state.OES_state}
                        areaCountyOptions={areaCountyOptions}
                      />
                      <FieldError
                        field_name={field.machine_name}
                        returningToPage={true}
                        returningToForm={true}
                        currentErrors={undefined}
                      />
                    </div>
                  );
                } else {
                  if (field.isGroup.machine_name === "OES_highly_comp_flag") {
                    return null;
                  }
                  if (field.isGroup.machine_name === "OES_rd_flag") {
                    if (
                      this.state.OES_soc_code !== undefined &&
                      this.state.OES_soc_code !== null
                    ) {
                      let socPrefix = this.state.OES_soc_code.substring(0, 2);
                      //xwalk soc R&D fields
                      if (socPrefix != "15" && socPrefix != "17") {
                        // not going to update this to strict equality in case of number to string conversion
                        return "";
                      }
                    } else {
                      return "";
                    }
                  }

                  let input_resolver = FieldResolver;
                  let showRequired =
                    field.isGroup.validate &&
                    field.isGroup.validate[0] === "required";
                  return (
                    <div>
                      {field.isGroup.label && (
                        <Label htmlFor={field.isGroup.machine_name}>
                          <span
                            dangerouslySetInnerHTML={{
                              __html: field.isGroup.label,
                            }}
                          />
                          <RequiredAsterisk
                            show={showRequired || schemaProps.required === true}
                          />
                        </Label>
                      )}
                      {field.isGroup.fields.map((f, index) => {
                        return (
                          <Field
                            key={index}
                            id={f.machine_name}
                            name={field.isGroup.machine_name}
                            formApi={formApi}
                            component={input_resolver(f.widget)}
                            type={f.widget}
                            schemaProps={{ ...f }}
                            value={
                              f.value !== undefined
                                ? f.value
                                : f.choice !== undefined
                                ? f.choice
                                : undefined
                            }
                            inputOnChange={(e) => {
                              this.handleChange(
                                e,
                                field.isGroup.machine_name,
                                formApi
                              );
                            }}
                          />
                        );
                      })}
                    </div>
                  );
                }
              })}
              <div className={"interior-button-group"}>
                <button
                  className={"usa-button usa-button-outline-cancel"}
                  type={"button"}
                  onClick={(e) => this.handleClear(e, formApi)}
                >
                  Clear
                </button>
                <button
                  className={"usa-button usa-button-primary"}
                  disabled={disableCalculate}
                  type="button"
                  onClick={(e) => this.handleCalculate(e, formApi)}
                >
                  Calculate
                </button>
              </div>
              <div className={inputRowClassesBox}>
                {schema.fields.map((field, index) => {
                  let input_resolver = FieldResolver;
                  let component = input_resolver(field.widget) || "input";
                  let schemaProps = { ...field };
                  let showRequired =
                    field.validate && field.validate[0] === "required";
                  let disabled = { background: "#D3D3D3" };
                  let value = undefined;

                  if (
                    field.isGroup &&
                    field.isGroup.machine_name === "OES_highly_comp_flag"
                  ) {
                    if (!this.state.ratesNotFound) {
                      return null;
                    }

                    showRequired =
                      field.isGroup.validate &&
                      field.isGroup.validate[0] === "required";
                    return (
                      <div>
                        {field.isGroup.label && (
                          <Label htmlFor={field.isGroup.machine_name}>
                            <span
                              dangerouslySetInnerHTML={{
                                __html: field.isGroup.label,
                              }}
                            />
                            <RequiredAsterisk
                              show={
                                showRequired || schemaProps.required === true
                              }
                            />
                          </Label>
                        )}
                        {field.isGroup.fields.map((f, index) => {
                          return (
                            <Field
                              key={index}
                              id={f.machine_name}
                              name={field.isGroup.machine_name}
                              formApi={formApi}
                              component={input_resolver(f.widget)}
                              type={f.widget}
                              schemaProps={{ ...f }}
                              value={
                                f.value !== undefined
                                  ? f.value
                                  : f.choice !== undefined
                                  ? f.choice
                                  : undefined
                              }
                              inputOnChange={(e) => {
                                this.handleChange(
                                  e,
                                  field.isGroup.machine_name,
                                  formApi
                                );
                              }}
                            />
                          );
                        })}
                      </div>
                    );
                  } else if (
                    field.machine_name === "OES_wage_level" ||
                    field.machine_name === "OES_per"
                  ) {
                    if (
                      formApi.getState().values["b4_is_full_time"] === "NO" &&
                      field.machine_name === "OES_per"
                    ) {
                      value = "Hour";
                      schemaProps.selection = ["Hour"];
                    }

                    return (
                      <div>
                        {field.label && (
                          <Label
                            hidden={field.hidden || field.labelHidden}
                            htmlFor={machine_name}
                          >
                            {field.code && <span>{`${field.code}. `}</span>}
                            <span
                              dangerouslySetInnerHTML={{
                                __html: field.label,
                              }}
                            />
                            <RequiredAsterisk
                              show={
                                showRequired || schemaProps.required === true
                              }
                            />
                            {field.tooltip && (
                              <Tooltip content={field.tooltip} />
                            )}
                          </Label>
                        )}
                        <Field
                          updatedValues={
                            field.machine_name === "OES_wage_level"
                              ? this.state.levelOptions
                              : undefined
                          }
                          key={index}
                          id={field.machine_name}
                          name={field.machine_name}
                          formApi={formApi}
                          formValues={formValues}
                          component={component}
                          type={field.widget}
                          disabled={
                            (field.disabled &&
                              field.disableWhenField !== undefined) ||
                            this.state.levelOptions.length === 0 ||
                            this.state.disableSubmitOtherOptions
                              ? FieldDisabled(
                                  field.disabled,
                                  field.disableWhenField,
                                  formApi
                                )
                              : field.disabled
                          }
                          validate={(values, allValues) =>
                            field.validate
                              ? validator(field.validate, allValues)(values)
                              : undefined
                          }
                          style={field.disabled ? disabled : undefined}
                          schemaProps={schemaProps}
                          defaultValue={
                            value !== undefined
                              ? value
                              : field.value !== undefined
                              ? field.value
                              : field.choice !== undefined
                              ? field.choice
                              : undefined
                          }
                          showRequired={showRequired}
                          inputOnChange={(e) => {
                            this.handleChange(e, field.machine_name, formApi);
                          }}
                        />
                        <FieldError
                          field_name={field.machine_name}
                          returningToPage={true}
                          returningToForm={true}
                          currentErrors={undefined}
                        />
                      </div>
                    );
                  }
                })}
                <Label htmlFor={"OES_prevailing_wage"}>
                  <span>Prevailing Wage</span>
                </Label>
                <NumericFormat
                  class={
                    this.state.disableSubmitOtherOptions
                      ? "wage-rate-input-style-disabled"
                      : undefined
                  }
                  style={wageRateStyle}
                  id={"OES_prevailing_wage"}
                  placeholder={"$nnnn.nn"}
                  prefix={"$"}
                  value={
                    this.state.prevailingWage === undefined
                      ? null
                      : this.state.prevailingWage
                  }
                  decimalScale={2}
                  fixedDecimalScale={true}
                  allowNegative={false}
                  disabled={true}
                />
                <div>
                  {this.state.showWageWarning ? (
                    <span>
                      <br />
                      Level wages cannot be provided for the occupation code{" "}
                      <b>{this.state.OES_soc_code}</b> due to limitations in the
                      OES data. The wage data may be at least: $115.00 hour,
                      $239,200 year. See{" "}
                      <a href="http://www.bls.gov/oes/">
                        http://www.bls.gov/oes/
                      </a>{" "}
                      for an explanation of why OES includes the footnote. Would
                      you like to use this wage?
                      <br />
                    </span>
                  ) : (
                    ""
                  )}
                  {this.state.showUseOtherOptions ? (
                    <span>
                      <br />
                      Leveled wages cannot be provided for the occupation code{" "}
                      <b>{this.state.OES_soc_code}</b> due to limitations in the
                      OES data. Filers may utilize a wage obtained from the OFLC
                      National Prevailing Wage Center by selecting F.12; or an
                      independent authoritative source, or other legitimate
                      sources of wage data, by selecting F.14.
                      <br />
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <div className={"button-group"}>
              <button
                className={"usa-button usa-button-outline-cancel"}
                type={"button"}
                onClick={(e) => this.handleCancel(e, formApi)}
              >
                Cancel
              </button>
              <button
                className={"usa-button usa-button-primary"}
                disabled={
                  this.state.prevailingWage === undefined ||
                  this.state.disableSubmitOtherOptions
                }
                type="button"
                onClick={(e) => this.handleSubmit(e, formApi)}
              >
                Submit
              </button>
            </div>
          </div>
        </SimpleModal>
      </div>
    );
  }
}

export default WageCalculator;
